import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33af7b24&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af7b24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33af7b24')) {
      api.createRecord('33af7b24', component.options)
    } else {
      api.reload('33af7b24', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33af7b24&scoped=true", function () {
      api.rerender('33af7b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/tenantPackage/index.vue"
export default component.exports